import React from 'react';

import type { ConversationStarter } from '@atlaskit/rovo-agent-components/ui/AgentConversationStarters';
import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { RovoAgentConversationStarters } from './index';

type RovoAgentConversationStartersOldProps = {
	agent: Agent;
	onConversationStarterClick: (conversationStarter: ConversationStarter) => void;
};

export const RovoAgentConversationStartersOld = ({
	agent,
	onConversationStarterClick,
}: RovoAgentConversationStartersOldProps): React.JSX.Element => (
	<RovoAgentConversationStarters
		agentId={agent.id}
		conversationStarters={agent.user_defined_conversation_starters}
		onConversationStarterClick={onConversationStarterClick}
	/>
);
